import { EasyEIA } from "../core/easyeia";

$("#reset-code-form").submit(function (e) {
	e.preventDefault();
	const json = EasyEIA.ConvertFormToJSON(this);
	const actionurl = e.currentTarget.action;

	if (json.confirm_password !== json.password) {
		$("#new-password").addClass("is-invalid");
		$("#new-password-feedback").text("Passwords don't match");
		return;
	}
	EasyEIA.POST(actionurl, json, (data) => {
		if (!data.success) {
			const type = data.type;
			if (type == "invalid_password") {
				$("#new-password").addClass("is-invalid");
				$("#new-password-feedback").text(data.message);
			} else {
				console.log(data);
			}
		} else {
			window.location.href = data.redirect;
		}
	});
});

$("#reset-form").submit(function (e) {
	e.preventDefault();
	const json = EasyEIA.ConvertFormToJSON(this);
	const actionurl = e.currentTarget.action;
	EasyEIA.POST(actionurl, json, (data) => {
		window.location.href = data.redirect;
	});
});

function comparePassword(pass1, pass2) {
	if (pass1 != pass2) {
		$("#password").addClass("is-invalid");
		$("#password-feedback").text("Passwords don't match");
		$("#signup-button").attr("disabled", true);
	} else {
		$("#password").removeClass("is-invalid");
		$("#password-feedback").text("");
		$("#signup-button").removeAttr("disabled");
	}
}

function checkPasswordRequirements(password) {
	let errors = 0;
	$(".pass-requirement").removeClass("text-danger");
	if (password.length < 8) {
		$("#pass-min").addClass("text-danger");
		$("#signup-button").attr("disabled", true);
		errors += 1;
	}
	return errors;
}

$("#password").bind("keyup change", (e) => {
	const value = $("#password").val();
	const errors = checkPasswordRequirements(value);
	if (errors > 0) {
		$("#password").addClass("is-invalid");
		$("#password-feedback").text("Passwords doesn't meet requirements");
		$("#signup-button").attr("disabled", true);
		return;
	}
	const value2 = $("#confirmpassword").val();
	comparePassword(value, value2);
});

$("#confirmpassword").bind("keyup change", (e) => {
	const value = $("#password").val();
	const value2 = $("#confirmpassword").val();
	comparePassword(value, value2);
});

$("#login-form").submit(function (e) {
	$("#login-message").addClass("d-none");
	$("#login-message").text("");
	e.preventDefault();
	const json = EasyEIA.ConvertFormToJSON(this);
	const actionurl = e.currentTarget.action;

	EasyEIA.POST(
		actionurl,
		json,
		undefined,
		(response) => {
			const data = response.data;
			if (!data.success) {
				window.location.href = data.redirect;
			} else {
				window.location.href = data.home_url;
			}
		},
		(error) => {
			const status = error.response.status;
			const data = error.response.data;

			if (data && (data.message || data.redirect)) {
				const url = data.redirect;
				if (url != undefined) {
					window.location.href = url;
					return;
				}

				$("#login_username").addClass("is-invalid");
				$("#login_password").addClass("is-invalid");
				$("#login-message").removeClass("d-none");
				$("#login-message").text(data.message);
				return;
			}

		},
	);
});

$("#signup-form").submit(function (e) {
	$(e.currentTarget).find(".form-control").removeClass("is-invalid");

	e.preventDefault();
	const json = EasyEIA.ConvertFormToJSON(this);
	const actionurl = e.currentTarget.action;

	EasyEIA.POST(actionurl, json, (data) => {
		if (!data.success) {
			const type = data.type;
			if (type === "user_exists") {
				$("#email").addClass("is-invalid");
				$("#email-feedback").text(data.message);
			} else if (type === "invalid_password") {
				$("#password").addClass("is-invalid");
				$("#password-feedback").text(data.message);
			} else if (type === "invalid_phone") {
				$("#number").addClass("is-invalid");
				$("#number-feedback").text(data.message);
			} else {
				console.log(data);
			}
		} else {
			window.location.href = data.redirect;
		}
	});
});
